import { AppBar, Avatar, Button, Toolbar } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import logo from './images/logo.png'

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      background:'#f0f2f5'
    },
    menuButton: {
      padding: 2.5,
      marginRight: 2,
      '&:hover': {
        color: '#c7a936',
        }
    },
    menuButton2: {
        padding: 2.5,
        marginRight: 2,
        '&:hover': {
          color: '#fff',
          }
      },
    title: {
      flexGrow: 1,
    },
    image: {
        width: 85,
        height: 42,
    },
 
}));

const AppNavBar = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <AppBar position="static" elevation={0} color="inherit" style={{padding: 10}}>
                <Toolbar>
                <div className={classes.title}>
                    <Avatar  variant="square" alt="Dev Arena" src={logo} style={{width:'200px',height:'50px'}}>
                        Dev Arena
                    </Avatar>
                </div>
                 <Button 
                            color="primary"
                            className={classes.menuButton}
                            variant="contained"
                            component={Link}
                            to="/login"
                        >
                            Log Out
                        </Button>
                </Toolbar>
            </AppBar>
        </div>
    )
}

export default AppNavBar;